<template>
  <div id="page-wrapper">
    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content container ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix">
            <div id="main" class="container-fluid">
              <div class="row row-offcanvas row-offcanvas-left clearfix">
                <main class="main-content col content-full-width" id="content" role="main">
                  <section id="userlist-manager" class="section">
                    <div class="container-fluid">
                      <div class="row mb-15">
                        <div id="vitamins" class="col-md-12">
                          <div class="company-settings col-card mh">
                            <h2>{{ $t('message.company_details') }}</h2>
                            <form action="">
                              <div class="row">
                                <div class="col-md-12 tab-nav">
                                  <button :class="activeTab === 0 ? 'active' : ''"
                                          @click.stop.prevent="setTab(0)"
                                          class="tab-link btn btn-link">
                                    {{ $t('message.company_info') }}
                                  </button>
                                  <button :class="activeTab === 1 ? 'active' : ''"
                                          @click.stop.prevent="setTab(1)"
                                          class="tab-link btn btn-link">
                                    {{ $t('message.user_settings') }}
                                  </button>
                                </div>
                                <div class="tab-content col-md-12" v-if="activeTab === 0">
                                  <form action="" class="companyform" @submit.prevent="saveCompany">
                                    <div class="form-row">
                                      <div class="col-md-12 mb-3"><label for="">
                                        {{ $t('message.company_name') }}
                                      </label>
                                        <input v-model="company.Title"
                                               name="Title"
                                               id="Title"
                                               type="text"
                                               class="styled-input form-control">
                                      </div>

                                      <div class="col-md-12 mb-3">
                                        <label for="">
                                          {{ $t('message.description') }}
                                        </label>
                                        <textarea v-model="company.Information"
                                                  name="Information"
                                                  id="Information"
                                                  class="styled-input form-control">
                                        </textarea>
                                      </div>
                                      <div class="col-md-12 mb-3">
                                        <label class="d-block" for="">{{ $t('message.company_logo') }}</label>
                                        <file-upload
                                          :image-url="company.Logo ? url + company.Logo.url : ''"
                                          class="styled-input"
                                          :name="'files'">
                                        </file-upload>
                                      </div>
                                      <div class="col-md-12 text-right">
                                        <button id="save_company" type="submit" class="btn btn-primary">
                                          {{ $t('message.save_company') }}
                                        </button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                                <div class="tab-content col-md-12" v-if="activeTab === 1">
                                  <div class="m-0 row">
                                    <div class="p-0 col-md-12 mb-3">
                                      <transition name="formslide" mode="out-in">
                                        <div class="tablecontainer" v-if="formOpen === false">
                                          <label class="d-flex justify-content-between align-items-baseline" for="">
                                            <button type="button" class="ml-auto btn btn-link"
                                                    @click.prevent.stop="openForm(null)">
                                              + {{ $t('message.create_new_tag') }}
                                            </button>
                                          </label>
                                        </div>
                                        <form v-else action="" @submit.prevent="saveTag($event,activeTag.id)">
                                          <div class="form-row ">
                                            <div class="col-md-12">
                                              <input :placeholder="$t('message.title')"
                                                     class="form-control styled-input"
                                                     type="text"
                                                     id="tagname"
                                                     name="tagname"
                                                     required
                                                     v-model="activeTag.description">
                                            </div>
                                          </div>
                                          <div class="form-row">
                                            <div class="col-md-12 text-right">
                                              <button type="button" class="btn btn-link"
                                                      @click.stop.prevent="closeForm">
                                                {{ $t('message.cancel') }}
                                              </button>
                                              <button class="btn btn-primary savetag"
                                              >
                                                {{ $t('message.save') }}
                                              </button>
                                            </div>
                                          </div>
                                        </form>

                                      </transition>
                                      <table class="table table-striped"
                                             :class="store.getters.getTheme === 'darkmode' ? 'table-dark' : ''">
                                        <thead>
                                        <tr>
                                          <th>{{ $t('message.tags') }}</th>
                                          <!--                                              <th>{{ $t('message.description') }}</th>-->
                                          <th>{{ $t('message.actions') }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr :data-id="tag.id" class="tag-item"
                                            v-for="tag in tags">
                                          <td class=" name">{{tag.description}}</td>
                                          <!--                                              <td class=" info">{{tag.information}}</td>-->
                                          <td class=" actions">
                                            <button type="button" @click.prevent.stop="openForm(tag)"
                                                    class="btn-link btn p-0">
                                              <i class="fas fa-edit"></i>
                                            </button>
                                            <button type="button" @click.prevent.stop="deleteTag(tag.id)"
                                                    class="btn-link btn p-0">
                                              <i class="far fa-trash-alt"></i>
                                            </button>
                                          </td>
                                        </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <div class="p-0 col-md-12 mb-3">

                                      <transition name="formslide" mode="out-in">
                                        <div v-if="!formPerkOpen">
                                          <label v-if="!formPerkOpen"
                                                 class="d-flex justify-content-between align-items-baseline" for="">
                                            <button type="button" class="ml-auto btn btn-link"
                                                    @click.prevent.stop="openPerkForm(null)">
                                              + {{ $t('message.create_a_new_perk') }}
                                            </button>
                                          </label>

                                        </div>
                                        <form v-else action="" @submit.prevent="savePerk($event,activePerk.id)">
                                          <div class="form-row ">
                                            <div class="col-md-12">
                                              <input :placeholder="$t('message.title')"
                                                     class="form-control styled-input"
                                                     required
                                                     type="text"
                                                     v-model="activePerk.title">
                                            </div>
                                          </div>
                                          <div class="form-row ">
                                            <div class="col-md-12">
                                        <textarea
                                          :placeholder="$t('message.description')"
                                          class="form-control styled-input"
                                          required
                                          v-model="activePerk.description"></textarea>
                                            </div>
                                          </div>
                                          <div class="form-row">
                                            <div class="col-md-12 text-right">
                                              <button type="button" class="btn btn-link"
                                                      @click.stop.prevent="closePerkForm">
                                                {{ $t('message.cancel') }}
                                              </button>
                                              <button type="button" class="btn btn-primary saveperk">
                                                {{ $t('message.save') }}
                                              </button>
                                            </div>
                                          </div>
                                        </form>

                                      </transition>
                                      <table class="table table-striped"
                                             :class="store.getters.getTheme === 'darkmode' ? 'table-dark' : ''">
                                        <thead>
                                        <tr>
                                          <th>{{ $t('message.perks') }}</th>
                                          <th>{{ $t('message.description') }}</th>
                                          <th>{{ $t('message.actions') }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr
                                          :data-id="perk.id"
                                          class=" tag-item"
                                          v-for="perk in perks">
                                          <td class=" name">{{perk.title}}</td>
                                          <td>{{perk.description}}</td>
                                          <td class=" actions">
                                            <button type="button" @click.prevent.stop="openPerkForm(perk)"
                                                    class="btn-link btn p-0">
                                              <i class="fas fa-edit"></i>
                                            </button>
                                            <button type="button" @click.prevent.stop="deletePerk(perk.id)"
                                                    class="btn-link btn p-0">
                                              <i class="far fa-trash-alt"></i>
                                            </button>
                                          </td>
                                        </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import Header from "../Header";
  import Nav from "../Nav";
  import axios from "../../axios-auth";
  import Userform from "../Users/Userform";
  import store from "../../store/store";
  import FileUpload from "../FileUpload";

  export default {
    components: {
      userForm: Userform,
      appHeader: Header,
      appNavbar: Nav,
      fileUpload: FileUpload,
    },
    created() {
      this.getTags();
      this.getPerks();
      this.getCompany();
    },
    methods: {
      setTab(t) {
        this.activeTab = t;
      },
      getCompany() {
        this.company = store.getters.getCompany
      },
      async uploadImage() {
    //    console.log('start image upload')
        const formElement = document.querySelector('.companyform');
        const logoinput = document.querySelector('#files');

        const fileData = new FormData(formElement);
        fileData.delete('Information');
        fileData.delete('Title');
        fileData.append(
          'ref', 'company'
        );
        fileData.append(
          'refId', this.company.id
        );
        fileData.append(
          'field', 'Logo'
        );
        if (logoinput.value) {
          return await this.axios.post('/upload', (fileData))
        } else {
          return 'no file';
        }
      },
      saveCompany(e) {
        const btnEl = document.querySelector('#save_company');
        btnEl.classList.add('loading');
        const logoinput = document.querySelector('#files');

        this.uploadImage().then(r => {
       //   console.log('upload promise', r)
        });


        const form = document.querySelector('.companyform');
        const formElements = form.elements;
        const fieldvalues = {};

        for (let i = 0; i < formElements.length; i++) {
          const currentElement = formElements[i];
          if (!['submit', 'file'].includes(currentElement.type)) {
            fieldvalues[currentElement.name] = currentElement.value;
          }
        }

        this.axios.put('/companies/' + this.company.id, fieldvalues)
          .then(res => {
            store.commit("setCompany", res.data);
        //    console.log('company saved', res.data)
            this.loadingSuccess(btnEl);
            this.logActivity('Edited company', 'info (HR)');
          })
          .catch(res => {
            btnEl.classList.remove('loading');
          });
      },
      openForm(tag) {
        if (!tag) {
          this.activeTag = {description: null};
        } else {
          this.activeTag = tag
        }
        this.formOpen = true
      },
      closeForm() {
        this.activeTag = {description: null};
        this.formOpen = false
      },
      deleteTag(id) {
        this.axios.delete('/tags/' + id).then(res => {
          //  console.log('delete request', res)
          this.getTags();
        })
      },
      validateTag() {
        let valid = true;
        if (!this.activeTag.description) {
          valid = false
        }
        return valid;
      },
      saveTag(e, id = null) {
        const el = document.querySelector('.savetag');
        el.classList.add('loading');
        if (this.validateTag()) {
          const tagData = {
            description: this.activeTag.description
          };
          if (id) {
            this.axios.put('/tags/' + id, tagData).then(res => {
              this.logActivity('Edited tag', 'info (HR)');
              this.getTags();
              this.loadingSuccess(el);
              // e.target.classList.remove('loading')
            }).catch(e => {
              el.classList.remove('loading')
            })
          } else {
            this.axios.post('/tags', tagData).then(res => {
              this.logActivity('Created tag', 'info (HR)');
              this.getTags();
              this.loadingSuccess(el);
              // e.target.classList.remove('loading')
            }).catch(e => {
              el.classList.remove('loading')
            })
          }
          this.formOpen = false;
        }
      },
      getTag(id) {
        this.axios.get('/tags/' + id).then(res => {
          this.activeTag = res.data
        })
      },
      getTags() {
        this.axios.get('/tags').then(res => {
          this.tags = res.data
        })
      },
      openPerkForm(tag) {
        if (!tag) {
          this.activePerk = {title: null, description: null};
        } else {
          this.activePerk = tag
        }
        this.formPerkOpen = true
      },
      closePerkForm() {
        this.activePerk = {title: null, description: null};
        this.formPerkOpen = false
      },
      deletePerk(id) {
        this.axios.delete('/perks/' + id).then(res => {
          //  console.log('delete request', res)
          this.getPerks();
        })
      },
      validatePerk() {
        let valid = true;
        if (!this.activePerk.title || !this.activePerk.description) {
          valid = false
        }
        return valid
      },
      savePerk(e, id = null) {
        const el = document.querySelector('.saveperk');
        el.classList.add('loading')
        if (this.validatePerk()) {
          const perkData = {
            title: this.activePerk.title,
            description: this.activePerk.description
          };
          if (id) {
            this.axios.put('/perks/' + id, perkData).then(res => {
              this.logActivity('Edited perk', 'info (HR)');
              //  console.log('put request', res);
              this.getPerks();
              this.loadingSuccess(el)
            }).catch(e => {
              el.classList.remove('loading')
            })
          } else {
            this.axios.post('/perks', perkData).then(res => {
              this.logActivity('Created perk', 'info (HR)');
              //  console.log('post request', res)
              this.getPerks();
              this.loadingSuccess(el)
            }).catch(e => {
              el.classList.remove('loading')
            })
          }
          this.formPerkOpen = false;
        }

      },
      getPerk(id) {
        this.axios.get('/perks/' + id).then(res => {
          //  console.log('p r',res)
          this.activePerk = res.data
        })
      },
      getPerks() {
        this.axios.get('/perks').then(res => {
          //  console.log('p r',res)
          this.perks = res.data
        })
      }
    }
    ,
    data() {
      return {
        store,
        activeTab: 0,
        formOpen: false,
        formPerkOpen: false,
        activePerk: {description: null},
        activeTag: {description: null},
        company: {},
        tags: [],
        perks: []
      }
    }
  }
</script>

<style>
  .companylogo {
    max-width: 100px;
    height: auto;
    margin-bottom: 15px;
  }

  .companyform label {
    text-transform: uppercase;
    font-weight: bold;
  }

  .formslide-enter-active {
    animation: form-in 1s ease-out forwards;
  }

  .formslide-leave-active {
    animation: form-out .3s ease-out forwards;
  }

  .company-settings form {
    position: relative;
    transform-origin: top center;
    overflow: hidden;
  }

  .company-settings label {
    z-index: 1;

  }


  @keyframes form-in {
    from {
      /*opacity: 0;*/
      max-height: 0px;
      /*transform: scaleY(0);*/
    }
    to {
      /*opacity: 1;*/
      max-height: 500px;
      /*transform: scaleY(1);*/
    }
  }

  @keyframes form-out {
    from {
      /*opacity: 1;*/
      max-height: 500px;
      /*transform: scaleY(1);*/
    }
    to {
      /*opacity: 0;*/
      max-height: 0px;
      /*transform: scaleY(0);*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Account/Company.vue